module.exports = __webpack_public_path__ + "media/10_10.21f60d4c.wav";